import { IInsurance } from "../types"

export const DEFAULT_INSURANCE: IInsurance = {
    insurance_type: 'travel_medical',
    details: {
      destination: '',
      destination_name: '',
      beneficiary_in_md: true,
      one_trip: true,
      start_date: '',
      end_date: '',
      purpose: 'tourism',
      covid_cover: false,
      insurance_form: '',
      insurance_company: '',
      sum_mdl: 0,
      sum_eur: 0,
    },
    beneficiary: [],
    payer: {
      user_id: '',
      first_name: '',
      last_name: '',
      phone: '',
      email: '',
    }
}